import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'
import store from '@/store'

import Forbidden from '@/pages/forbidden'
import Login from '@/pages/login'
import Logout from '@/pages/logout'

import Author from '@/pages/author'
import AuthorRoutes from './author'
import Client from '@/pages/client'
import ClientRoutes from './client'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: { name: 'AuthorHome' }
    },
    {
      path: '/author',
      name: 'Author',
      meta: {
        requireAuth: true
      },
      component: Author,
      redirect: { name: 'AuthorHome' },
      children: AuthorRoutes.routes
    },
    {
      path: '/client/:id',
      name: 'Client',
      meta: {
        requireAuth: true
      },
      component: Client,
      redirect: { name: 'ClientRecords' },
      children: ClientRoutes.routes
    },
    {
      path: '/login',
      name: 'Login',
      meta: {
        requireAuth: false
      },
      component: Login
    },
    {
      path: '/logout',
      name: 'Logout',
      meta: {
        requireAuth: false
      },
      component: Logout
    },
    {
      path: '/503',
      name: 'Forbidden',
      component: Forbidden
    },
    {
      path: '*',
      redirect: { name: 'Forbidden' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requireAuth = to.matched.some(record => record.meta.requireAuth)
  if (requireAuth) {
    store.commit('loader/open')
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        store.commit('loader/close')
        next()
      } else {
        store.commit('loader/close')
        next({
          path: '/login',
          query: {
            redirect: to.fullPath
          }
        })
      }
    })
  } else {
    next()
  }
})

export default router
